import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {resetSourceRoute} from '../../shared/actions';
import {commentsCount} from '../../feedbacks/actions';

import {actionCenterClick, fetchNotifications} from '../actions';

import Layout from '../../shared/components/layouts/MainLayout';
import Feedback from '../../feedbacks/containers/Feedback';

import Actions from '../components/ActionList';
import Updates from '../components/UpdateList';

import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  PageViewName,
  TrackEventName,
} from '../../shared/constants/SegmentEvents';

class Notifications extends Component {
  componentDidMount() {
    this.props.commentsCount();
    this.props.fetchAll();
    segmentEventTracker.trackPageView(PageViewName.NOTIFICATIONS_VIEWED);
  }

  onBack = () => {
    this.props.push(this.props.sourceRoute);
    this.props.resetSource();
    segmentEventTracker.trackEvent(TrackEventName.BACK_CLICKED);
  };

  emptyState = () => {
    return (
      <section className="cardSection">
        <h2 className="subhead"> No Notifications </h2>
      </section>
    );
  };

  onClickFeedbackItem = e => {
    const choice = e.target.value;
    switch (choice) {
      case 'no':
        segmentEventTracker.trackEvent(
          TrackEventName.IS_PAGE_HELPFUL_NO_CLICKED,
        );
        break;
      case 'yes':
        segmentEventTracker.trackEvent(
          TrackEventName.IS_PAGE_HELPFUL_YES_CLICKED,
        );
        break;
      case 'other':
        segmentEventTracker.trackEvent(
          TrackEventName.IS_PAGE_HELPFUL_OTHER_CLICKED,
        );
        break;
      default:
        break;
    }
  };

  onCancelFeedback = () => {
    segmentEventTracker.trackEvent(TrackEventName.CANCEL_CLICKED);
  };

  onSubmitFeedback = () => {
    segmentEventTracker.trackEvent(TrackEventName.SEND_FEEDBACK_CLICKED);
  };

  render() {
    return (
      <Layout
        header="Notifications"
        backButtonAction={this.onBack}
        gridClassName="--narrow">
        <Feedback
          type="notifications_page"
          onClickFeedbackItem={this.onClickFeedbackItem}
          onCancel={this.onCancelFeedback}
          onSubmit={this.onSubmitFeedback}
        />
        <div className="ds-card">
          {this.props.notifications.length === 0 && this.emptyState()}

          <Actions
            items={this.props.notifications}
            push={this.props.push}
            actionCenterClick={this.props.actionCenterClick}
          />
          <Updates
            items={this.props.notifications}
            push={this.props.push}
            actionCenterClick={this.props.actionCenterClick}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    notifications: state.notifications.all,
    sourceRoute: state.shared.routes.source,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    push: url => { 
      url && dispatch(push(url))
    },
    resetSource: () => {
      dispatch(resetSourceRoute());
    },
    fetchAll: () => {
      dispatch(fetchNotifications('action_center_show'));
    },
    actionCenterClick: (id, onSuccess) => {
      dispatch(actionCenterClick(id, onSuccess));
    },
    commentsCount: () => {
      dispatch(commentsCount('notifications_page'));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/features/notifications/containers/Notifications.js